<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">消息名称：</span>
        </div>
        <el-input v-model="formData.messageName" size="small" style="width: 280px" :maxlength="10" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">描述：</span>
        </div>
        <el-input v-model="formData.description" size="small" style="width: 280px"  />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">文本内容：</span>
        </div>
        <el-input type="textarea" :rows="3" v-model="formData.textContent" size="small" style="width: 280px" :maxlength="200" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">服务类型：</span>
        </div>
        <el-input v-model="formData.serviceType" size="small" style="width: 280px" :maxlength="10" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">处理状态：</span>
        </div>
        <el-input v-model="formData.processingStatus" size="small" style="width: 280px" :maxlength="10" />
      </div>

      <div class="form-line">
        <div class="textBox" style="vertical-align: top">
          <span class="line-text">备注：</span>
        </div>
        <el-input type="textarea" :rows="3" v-model="formData.memo" size="small" style="width: 280px" />
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../utils/toBase64'
  import $ from 'jquery'
  import {api} from '../../api/Message'
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'
  import UploadImgList from '../../../components/Input/UploadImgList'

  export default {
    components: {
      UploadImgList,
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'message-template-modify',
    data () {
      return {
        breadcrumb: [{
          value: '智慧消息',
          name: 'message-template-manage'
        }, {
          value: '消息模板'
        }],
        mainTitle: '修改消息模板',
        subheading: '',

        formData: {
          messageName: '',
          description: '',
          textContent: '',
          serviceType: '',
          processingStatus: '',
          memo: '',
        },
      }
    },
    created () {
      this.getMessageTemplateByCode(this.$route.params.id)
    },
    methods: {
      getMessageTemplateByCode (code) {
        this.$axios.get(`${api.getMessageTemplateByCode}/${code}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let resData = res.data.data
              this.formData = resData
            }
          })
          .catch(errorHandler('查询失败'))
      },

      toManagePage () {
        this.$router.push({
          name: 'message-template-manage'
        })
      },

      confirm () {
        if (!this.formData.messageName) {
          nError('请输入消息名称')
          return false
        }
        if (!this.formData.description) {
          nError('请输入描述')
          return false
        }
        if (!this.formData.textContent) {
          nError('请输入文本内容')
          return false
        }
        if (!this.formData.serviceType) {
          nError('请输入服务类型')
          return false
        }
        if (!this.formData.processingStatus) {
          nError('请输入处理状态')
          return false
        }
        this.$axios.post(api.updateMessageTemplate, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('修改成功')
              this.toManagePage()
            }
          })
          .catch(errorHandler('修改失败'))
      },
      cancel () {
        this.toManagePage()
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 122px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 110px 0 140px;
    margin: 40px 0 0 0;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 36px;
    line-height: 120px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 50px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>

<style lang="less">
  .el-switch {
    height: 30px;
  }
</style>




// WEBPACK FOOTER //
// src/view/MessageService/MessageTemplate/MessageTemplateModify.vue